import React from 'react';
import { styled } from '@this/constants/themes';
import _ from 'lodash';

import { AirRoutePolicies } from '@this/components/reserve_trip/reserve_confirm/air_route_policies';
import SimpleLoading from '../../shared/simple_loading/simple_loading';

import ReserveConfirmOutlineTemplate from './outline/outline.template';
import ReserveConfirmRoutingsTemplate from './routings/routings.template';

import type { Props } from './reserve_confirm_pc.template';

import StepBar from '../../step_bar';
import { steps } from './reserve_confirm';

const ReserveConfirmSpTemplate: React.FC<Props> = ({
  service,
  store,
  loading,
  responseError,
  returning,
  itemsBlankError,
  showError,
  handleBackToSelectClick,
  handlePaymentSubmit
}) => (
  <div className="reserve_confirm" style={loading ? { height: '100vh' } : undefined}>
    <div className="content-wrapper">
      <div className="content-body">
        {loading ? (
          <SimpleLoading />
        ) : responseError ? (
          responseError ===
          '検索条件の紐付けに失敗いたしました。おそれいりますが、下記のリンクを確認の上、再度ご予約をおねがいいたします。' ? (
            <ReturningError>
              検索条件の紐付けに失敗いたしました。
              <br />
              おそれいりますが、下記のリンクを確認の上、再度ご予約をおねがいいたします。
              <br />
              <br />
              <KnowledgeLink
                href="https://aitravel.jp/knowledges/000001106"
                target="_blank"
                rel="noopener noreferrer"
              >
                エラーメッセージが表示されて、交通機関・ホテルの予約ができない場合はどうすればいいですか？
              </KnowledgeLink>
            </ReturningError>
          ) : (
            <ReturningError>{responseError}</ReturningError>
          )
        ) : returning ? (
          <>
            <ReturningError>
              この手配依頼はすでに受け付けられている可能性があります。
              <br />
              <a href="/trips">こちら</a>
              から依頼済みの旅程をご確認ください。
              <br />
              該当するご旅程が確認できない場合は、もう一度ご依頼ください。
            </ReturningError>
            <BackTop>
              <a href="/">トップへ戻る</a>
            </BackTop>
          </>
        ) : itemsBlankError ? (
          <>
            <ReturningError>
              検索条件に該当する商品がありません。検索条件を変更して再度検索してください。
              <br />
              5秒後に検索画面へ遷移します。
            </ReturningError>
            <BackTop>
              <a href="/">トップへ戻る</a>
            </BackTop>
          </>
        ) : !store?.reserveInfo || !store?.reserveInfo.reservingTrip || !store?.queries ? (
          <ShowError>
            通信環境が不安定です。
            <br />
            時間をおいてもう一度お試しください。
          </ShowError>
        ) : showError ? (
          <ShowError>
            通信環境が不安定です。
            <br />
            時間をおいてもう一度お試しください。
          </ShowError>
        ) : (
          <>
            <WrapHeader>
              <StepBar steps={steps} index={store.stepIndex} type="thin" />
            </WrapHeader>
            <OutlineWrapper>
              <ReserveConfirmOutlineTemplate service={service} reserveInfo={store.reserveInfo} />
            </OutlineWrapper>
            {store.reserveInfo.reservingTrip.airRouteDetail && (
              <OutlineWrapper>
                <AirRoutePolicies airRoutePolicies={store.reserveInfo.reservingTrip.airRouteDetail} />
              </OutlineWrapper>
            )}
            <ReserveConfirmRoutingsTemplate
              store={store}
              handleBackToSelectClick={handleBackToSelectClick}
              handlePaymentSubmit={handlePaymentSubmit}
            />
          </>
        )}
      </div>
    </div>
  </div>
);

const baseMargin = '20px';

const ReturningError = styled.div`
  padding: ${baseMargin};
  color: ${props => props.theme.redColor};
`;

const KnowledgeLink = styled.a`
  color: ${props => props.theme.accentColor};
  text-decoration: underline;
  &:hover {
    color: ${props => props.theme.accentColorHover};
  }
`;

const ShowError = styled.div`
  padding: ${baseMargin};
  color: ${props => props.theme.redColor};
`;

const BackTop = styled.div`
  margin-top: ${baseMargin};
  text-align: center;
  text-decoration: underline;
`;

const WrapHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const OutlineWrapper = styled.div`
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  padding-bottom: 20px;
`;

export default ReserveConfirmSpTemplate;
